"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorage = void 0;
const useStorage = (key) => {
    const getStoredValue = () => {
        const curr = localStorage.getItem(key);
        if (curr) {
            return JSON.parse(curr);
        }
        else {
            return undefined;
        }
    };
    const setStoreValue = (value) => {
        if (value !== undefined)
            localStorage.setItem(key, JSON.stringify(value));
        else
            localStorage.removeItem(key);
    };
    return [getStoredValue, setStoreValue];
};
exports.useStorage = useStorage;
